import { render } from "./PlatOrderStatisticDetail.vue?vue&type=template&id=798d12fa&scoped=true"
import script from "./PlatOrderStatisticDetail.vue?vue&type=script&lang=js"
export * from "./PlatOrderStatisticDetail.vue?vue&type=script&lang=js"

import "./PlatOrderStatisticDetail.vue?vue&type=style&index=0&id=798d12fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798d12fa"]])

export default __exports__